export const NULL = null;
export const PROVIDER = "Provider";
export const CLINIC = "Clinic";
